import React from 'react'
import styles from './TourneyNextUp.module.css'
import useTourneyNextUpDetails from '@/src/hooks/data/useTourneyNextUpDetails';

export default function TourneyNextUp({ activeGame }) {
    const details = useTourneyNextUpDetails(activeGame)
    const { ante, smallBlind, bigBlind, minutesLeft, level } = details;

    if (!details.smallBlind || !details.bigBlind) {
        return null;
    }

    return (
        <div className={styles.tourneyNextUpContainer}>
            <div className={styles.tourneyNextUpHeader}>
                Next up:
            </div>
            <div className={styles.tourneyNextUpBlinds}>
                {smallBlind}/{bigBlind} ({ante})
            </div>
            <div className={styles.tourneyNextUpTimeLeft}>
                {
                    minutesLeft > 0 ? `${minutesLeft} ${minutesLeft === 1 ? 'min' : 'mins'} left` : "Few seconds left"
                }
            </div>
        </div>
    )
}
